// JavaScript code for acf_blocks/definitions-block component
(($) => {

     "use strict";
     console.log("acf_blocks/definitions-block scripts loaded...");

     /**
      * If the block is not present on the page, we don't need to run the code
      */
     if ( ! $(".acf-blocks-definitions-block").length ) return;

     /**
      * definitionsBlockObject is an object injected via wp_localize_script() in the PHP file
      * It contains the following properties:
      *   - ajax_url: the URL to the admin-ajax.php file
      *   - nonce: a nonce value for security purposes
      */
     const { ajax_url, nonce } = definitionsBlockObject || {};
     const loader = $("#loading-spinner").html();
     const shareUrls = {
          facebook: "https://www.facebook.com/sharer/sharer.php?u=",
          twitter: "https://twitter.com/share?url=",
          linkedin: "https://www.linkedin.com/shareArticle?url=",
     };

     /**
      * On page load, checks if the URL contains a hash and if so, fetches the post content
      * related to that hash and displays it in the main content area
      */
     $(document).ready( () => hashChangeHandler() );

     /**
      * On window resize, shows or hides the navigation menu links container based on the window width
      */
     $(window).resize(() => {
          if ( $(window).width() > Breakpoints.md ) {
               $(".navigation-menu .links-container").show();
               $(".navigation-menu .links-container a").show();
          } else {
               $(".navigation-menu .links-container").hide();
               $(".navigation-menu .links-container a.active").hide();
          }
     });

     /**
      * On hash change, fetches the post content related to the hash and displays it in the main content area
      * This is useful for when the user clicks the browser back or forward buttons
      */
     $(window).on("hashchange", () => hashChangeHandler());

     /**
      * On click of the dropdown button, shows or hides the navigation menu links container
      */
     $(".navigation-menu").on("click", ".dropdown-btn", () => {
          $(".navigation-menu .links-container").slideToggle();
     });

     /**
      * On click of the next or previous button, fetches the post content related to the next or previous link
      * in the navigation menu and displays it in the main content area.
      * Also updates the text of the next and previous buttons based on the active link
      */
     $(".next-prev").on("click", "button", function(e) {
          if ($(this).hasClass("btn-next")) {
               const next = $(".navigation-menu .links-container a.active").next();
               if (next.length) {
                    next.trigger("click");
               } else {
                    $(".navigation-menu .links-container a:first").trigger("click");
               }
          } else {
               const prev = $(".navigation-menu .links-container a.active").prev();
               if (prev.length) {
                    prev.trigger("click");
               } else {
                    $(".navigation-menu .links-container a:last").trigger("click");
               }
          }

          // Update the btn-next and btn-prev texts based on the active link
          updateNextPrevButtonsText();
     });

     /**
      * On click of a share button, opens a new window with the share URL and the current post URL
      */
     $(".share-posts").on("click", ".group-buttons button", function(e) {
          e.preventDefault();
          const shareUrl = shareUrls[$(this).data("share")];
          const postUrl = window.location.href;
          window.open(shareUrl + postUrl, "_blank");
     });

     /**
      * On click of a link in the navigation menu, fetches the post content related to the clicked link
      */
     $(".navigation-menu").on("click", ".links-container a", async function(e) {
          e.preventDefault();
          $(this).addClass("active").siblings().removeClass("active");
          const post_id = $(this).data("post-id");
          // Updates the URL hash without reloading the page
          window.history.pushState("", "", $(this).attr("href"));
          const content = await fetchDefinitionPostContent(post_id);
          $(".main-content .content-block").html(content);

          if ( $(window).width() <= Breakpoints.md ) {
               $(".navigation-menu .dropdown-btn span").text($(this).text());
               $(".navigation-menu .links-container").hide();
               $(this).hide().siblings().show();
          }
          
          // Scroll to the top of the page
          $(window).scrollTop(0);
          // Update the btn-next and btn-prev texts based on the active link
          updateNextPrevButtonsText();
     });

     /**
      * Updates the text of the next and previous buttons based on the active link in the navigation menu
      * @returns {void}
      */
     function updateNextPrevButtonsText() {
          const active = $(".navigation-menu .links-container a.active");
          const first = $(".navigation-menu .links-container a:first");
          const last = $(".navigation-menu .links-container a:last");
          $(".next-prev .btn-next span").text(active.next().text() || first.text());
          $(".next-prev .btn-prev span").text(active.prev().text() || last.text());
     }

     /**
      * This function is called when the hash changes in the URL or when the page loads and
      * there is a hash in the URL. It fetches the post content related to the hash and displays it
      * @returns {Promise<void>}
      */
     async function hashChangeHandler() {
          const hash = window.location.hash;
          if ( ! hash ) {
               if ( $(window).width() <= Breakpoints.md ) {
                    $(".navigation-menu .links-container").hide();
                    $(".navigation-menu .links-container a.active").hide().siblings().show();
               }
               return;
          }
          const link = $(".navigation-menu .links-container a[href='" + hash + "']");
          if ( !link.hasClass("active") ) {
               link.trigger("click");
          }
     }

     /**
      * Fetches the post content related to the post ID passed as an argument
      * @param {number} post_id              The ID of the post to fetch
      * @returns {Promise<string>}           The post content
      */
     async function fetchDefinitionPostContent( post_id ) {
          try {
               $(".main-content .content-block").html(loader);
               const response = await $.ajax({
                    url: ajax_url,
                    method: "GET",
                    data: {
                         action: "get_definition_by_id",
                         definition_id: post_id,
                         _nonce: nonce
                    }
               }).promise();
               
               return response;
          } catch (error) {
               console.error(error);
               return "Error fetching content. Please, try again.";
          }
     }

})(jQuery);